import * as React from 'react';
import { rem } from 'polished';
import Button from '../Button';
import Icon from '../Icon';
import styled, { useTheme } from 'styled-components';
const Wrapper = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Title = styled.div `
  text-align: center;
  color: ${({ theme }) => theme.inactiveColor};
  font-size: ${rem(32)};
  font-weight: 500;
`;
const Spacer = styled.div `
  height: ${rem(20)};
`;
const NotFound = ({ className, icon, title, onClickAction, actionLabel, }) => {
    const theme = useTheme();
    return (React.createElement(Wrapper, { className: className },
        icon && React.createElement(Icon, { name: icon, size: "xxl", color: theme.inactiveColor }),
        icon && title && React.createElement(Spacer, null),
        title && React.createElement(Title, null, title),
        onClickAction && actionLabel && (React.createElement(React.Fragment, null,
            React.createElement(Spacer, null),
            React.createElement(Button, { primary: true, onClick: onClickAction }, actionLabel)))));
};
export default NotFound;
